/**
 * Frontend Theme Provider
 *
 * Imports and applies the EXACT CSS from the frontend application.
 * This ensures preview components render identically to the frontend.
 *
 * IMPORTANT: This imports the frontend's index.css which includes:
 * - Tailwind base, components, and utilities
 * - Frontend-specific CSS variables
 * - Frontend-specific component styles
 */

import React from 'react';
// Import the frontend's CSS from vendored copy - this brings in Tailwind + all frontend styles
import '../../../vendor/frontend-css/index.css';

interface FrontendThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Wraps preview in a container that uses the frontend's styling
 *
 * The wrapper class 'frontend-preview-scope' ensures frontend styles
 * are applied only within the preview, not globally in the admin.
 */
export const FrontendThemeProvider: React.FC<FrontendThemeProviderProps> = ({ children }) => {
  return (
    <div className="frontend-preview-scope">
      {/* Apply frontend app background - matches frontend body style */}
      <div className="bg-[#121212] text-white p-4 rounded-lg font-gilroy">{children}</div>
    </div>
  );
};
